<template>
	<div class="navbar navbar-white">
		<div class="container">
			<div class="navbar-header">
				<div class="navbar-toggle collapsed" data-toggle="collapse" data-target="#test-collapse" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="span-text">Catálogo</span>
					<i class="fa fa-bars" aria-hidden="true"></i>
				</div> 
				<a v-link="{ path: '/' }">
					<div class="logo-principal"></div>
				</a>
			</div>
			<div class="navbar-body">
				<div class="collapse navbar-collapse no-padding pull-right" id="test-collapse">
					<div class="dropdown">
						<button class="dropbtn" v-link="{ path: '/almacenamiento?page=1' }" @click="resetFilters(1)">Almacenamiento</button>
						<div class="dropdown-content">
							<span v-link="{ path: '/almacenamiento?page=1&filter=2&color=true' }" @click="setSubcategory(2)">
								<img src="../images/icons/buro.png" alt="">Burós
							</span>
							<span v-link="{ path: '/almacenamiento?page=1&filter=3&color=true' }" @click="setSubcategory(3)">
								<img src="../images/icons/cajonera.png" alt="">Cajoneras
							</span>
							<span v-link="{ path: '/almacenamiento?page=1&filter=4&color=true' }" @click="setSubcategory(4)">
								<img src="../images/icons/muebles-tv.png" alt="">Muebles de TV
							</span>
							<span v-link="{ path: '/almacenamiento?page=1&filter=40&color=true' }" @click="setSubcategory(40)">
								<img src="../images/icons/consola.png" alt="">Consolas
							</span>
							<span v-link="{ path: '/almacenamiento?page=1&filter=33&color=true' }" @click="setSubcategory(33)">
								<img src="../images/icons/libreros.jpg" alt="">Libreros
							</span>
							<span class="margin-left-extra" v-link="{ path: '/almacenamiento?page=1&filter=5&color=true' }" @click="setSubcategory(5)">Sets</span>
							<span class="margin-left-extra" v-link="{ path: '/almacenamiento?page=1' }" @click="resetFilters(1)">Ver todos</span>
						</div>
					</div>
					<div class="dropdown">
						<button class="dropbtn" v-link="{ path: '/sillas?page=1' }" @click="resetFilters(6)">Sillas</button>
						<div class="dropdown-content">
							<span v-link="{ path: '/sillas?page=1&filter=7&color=true' }" @click="setSubcategory(7)">
								<img src="../images/icons/comedor.png" alt="">Comedor
							</span>
							<span v-link="{ path: '/sillas?page=1&filter=34&color=true' }" @click="setSubcategory(34)">
								<img src="../images/icons/bar-silla.png" alt="">Bar
							</span>
							<span v-link="{ path: '/sillas?page=1&filter=9&color=true' }" @click="setSubcategory(9)">
								<img src="../images/icons/lounge.png" alt="">Lounge
							</span>
							<span v-link="{ path: '/sillas?page=1&filter=8&color=true' }" @click="setSubcategory(8)">
								<img src="../images/icons/oficina.png" alt="">Oficina
							</span>
							<span v-link="{ path: '/sillas?page=1&filter=10&color=true' }" @click="setSubcategory(10)">
								<img src="../images/icons/exterior-sillas.png" alt="">Exterior
							</span>
							<span v-link="{ path: '/sillas?page=1&filter=39&color=true' }" @click="setSubcategory(39)">
								<img src="../images/icons/banca.png" alt="">Bancas
							</span>
							<span v-link="{ path: '/sillas?page=1&filter=11&color=true' }" @click="setSubcategory(11)">
								<img src="../images/icons/kids.png" alt="">Kids
							</span>
							<span class="margin-left-extra" v-link="{ path: '/sillas?page=1&filter=35&color=true' }" @click="setSubcategory(35)">Sets</span>
							<!-- <span href="#"><img src="../images/icons/bar.png" alt="">Bar</span> -->
							<!-- <span class="margin-left-extra" href="#">Sets</span> -->
							<span class="margin-left-extra" v-link="{ path: '/sillas?page=1' }" @click="resetFilters(6)">Ver todos</span>
						</div>
					</div>
					<div class="dropdown">
						<button class="dropbtn" v-link="{ path: '/mesas?page=1' }" @click="resetFilters(12)">Mesas</button>
						<div class="dropdown-content">
							<!-- <span href="#"><img src="../images/icons/comedor-mesa.png" alt="">Comedor</span> -->
							<span v-link="{ path: '/mesas?page=1&filter=37&color=true' }" @click="setSubcategory(37)">
								<img src="../images/icons/comedor-mesa.png" alt="">Comedor
							</span>
							<span v-link="{ path: '/mesas?page=1&filter=17&color=true' }" @click="setSubcategory(17)">
								<img src="../images/icons/bar.png" alt="">Bar
							</span>
							<span v-link="{ path: '/mesas?page=1&filter=14&color=true' }" @click="setSubcategory(14)">
								<img src="../images/icons/centro-y-lateral.png" alt="">Central & lateral
							</span>
							<span v-link="{ path: '/mesas?page=1&filter=13&color=true' }" @click="setSubcategory(13)">
								<img src="../images/icons/escritorios.png" alt="">Escritorio
							</span>
							<span v-link="{ path: '/mesas?page=1&filter=15&color=true' }" @click="setSubcategory(15)">
								<img src="../images/icons/exterior-mesa.png" alt="">Exterior
							</span>
							<span v-link="{ path: '/mesas?page=1&filter=16&color=true' }" @click="setSubcategory(16)">
								<img src="../images/icons/kids-mesa.png" alt="">Kids
							</span>
							<span class="margin-left-extra" v-link="{ path: '/mesas?page=1&filter=18&color=true' }" @click="setSubcategory(18)">Sets</span>
							<span class="margin-left-extra" v-link="{ path: '/mesas?page=1' }" @click="resetFilters(12)">Ver todos</span>
						</div>
					</div>
					<div class="dropdown">
						<button class="dropbtn" v-link="{ path: '/salas?page=1' }" @click="resetFilters(19)">SALAS</button>
						<div class="dropdown-content">
							<span v-link="{ path: '/salas?page=1&filter=20&color=true' }" @click="setSubcategory(20)">
								<img src="../images/icons/seccionales.png" alt="">Seccionales
							</span>
							<span v-link="{ path: '/salas?page=1&filter=21&color=true' }" @click="setSubcategory(21)">
								<img src="../images/icons/sofa.png" alt="">Sofás
							</span>
							<span v-link="{ path: '/salas?page=1&filter=22&color=true' }" @click="setSubcategory(22)">
								<img src="../images/icons/sillones.png" alt="">Sillones
							</span>
							<!-- <span v-link="{ path: '/salas?page=1&filter=23&color=true' }" @click="setSubcategory(23)">
								<img src="../images/icons/lounge.png" alt="">Lounge
							</span> -->
							<span v-link="{ path: '/salas?page=1&filter=24&color=true' }" @click="setSubcategory(24)">
								<img src="../images/icons/exterior.png" alt="">Exterior
							</span>
							<span class="margin-left-extra" v-link="{ path: '/salas?page=1&filter=25&color=true' }" @click="setSubcategory(25)">Sets</span>
							<span class="margin-left-extra" v-link="{ path: '/salas?page=1' }" @click="resetFilters(19)">Ver todos</span>
						</div>
					</div>
					<div class="dropdown">
						<button class="dropbtn" v-link="{ path: '/lamparas?page=1' }" @click="resetFilters(26)">Lámparas</button>
						<div class="dropdown-content">
							<span v-link="{ path: '/lamparas?page=1&filter=27&color=true' }" @click="setSubcategory(27)">
								<img src="../images/icons/techo-y-pared.png" alt="">Techo & Pared
							</span>
							<span v-link="{ path: '/lamparas?page=1&filter=28&color=true' }" @click="setSubcategory(28)">
								<img src="../images/icons/piso.png" alt="">Piso
							</span>
							<span v-link="{ path: '/lamparas?page=1&filter=29&color=true' }" @click="setSubcategory(29)">
								<img src="../images/icons/lampara-mesa.png" alt="">Mesa
							</span>
							<span class="margin-left-extra" v-link="{ path: '/lamparas?page=1' }" @click="resetFilters(26)">Ver todos</span>
						</div>
					</div>
					<div class="dropdown">
						<button class="dropbtn" v-link="{ path: '/accesorios?page=1' }" @click="resetFilters(30)">Accesorios</button>
						<div class="dropdown-content">
							<span v-link="{ path: '/accesorios?page=1&filter=31&color=true' }" @click="setSubcategory(31)">
								<img src="../images/icons/espejo.jpg" alt="">Espejos
							</span>
							<span v-link="{ path: '/accesorios?page=1&filter=32&color=true' }" @click="setSubcategory(32)">
								<img src="../images/icons/cojin.jpg" alt="">Cojines
							</span>
							<span v-link="{ path: '/accesorios?page=1&filter=36&color=true' }" @click="setSubcategory(36)">
								<img src="../images/icons/tapetes.jpg" alt="">Tapetes
							</span>
							<span v-link="{ path: '/accesorios?page=1&filter=38&color=true' }" @click="setSubcategory(38)">
								<img src="../images/icons/exterior.jpg" alt="">Exterior
							</span>
							<span v-link="{ path: '/accesorios?page=1&filter=41&color=true' }" @click="setSubcategory(41)">
								<img src="../images/icons/decoracion.png" alt="">Decoración
							</span>
							<span v-link="{ path: '/accesorios?page=1' }" @click="resetFilters(30)">Ver todos</span>
						</div>
					</div>
					<div class="dropdown">
						<button class="dropbtn" v-link="{ path: '/novedades?page=1' }" @click="resetFilters(0)">Novedades</button>
					</div>
					<div class="dropdown">
						<button class="dropbtn" v-link="{ path: '/especiales?page=1' }" @click="resetFilters(0)" style="padding-right:0">Especiales</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	resetColors,
	getColors,
	resetFilterPrice
} from '../store/actions';

export default{
	ready: function() {
		$('.dropbtn').on('click', e => {
			// e.preventDefault();
			// e.stopPropagation();
			$('.dropbtn').removeClass('active');
			$(e.target).addClass('active');
		});

		$('.dropdown-content').on('click', e => {
			let parent = $(e.target).parent().siblings()[0];
			let btn = $(parent);

			if ($(window).width() < 992) {
				if (btn.hasClass('active')) {
					$('.navbar-toggle').trigger('click');
				}
			}
			
			if (!btn.hasClass('active')) {
				btn.addClass('active');
			}
		});
	},

	vuex: {
		actions: {
			resetColors,
			getColors,
			resetFilterPrice
		}
	},

	methods: {
		resetFilters (same_cat) {
			this.resetColors();
			this.resetFilterPrice();
			let cat = null;

			switch (this.$route.name) {
				case 'almacenamiento':
					cat = 1;
					break;
				case 'sillas':
					cat = 6;
					break;
				case 'mesas':
					cat = 12;
					break;
				case 'salas':
					cat = 19;
					break;
				case 'lamparas':
					cat = 26;
					break;
				case 'accesorios':
					cat = 30;
					break;
			}

			if (cat == same_cat) {
				this.resetColors();
				this.getColors(cat);
			}

			$('.sub-filters').prop('checked', false);
		},

		setSubcategory (sub) {
			this.resetFilters();
			this.resetColors();
			this.getColors(sub);

			$('.sub-filters').each((i, f) => {
				if (f.id == sub) {
					$(f).prop('checked', true);
				}
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// Subnavigation.vue?0b7f557f